import { Box } from "@material-ui/core";
import { SPView } from "components/common/MediaQuery";
import React from "react";
import { useSelector } from "store";

import { StreamingAnnouncement } from "./StreamingAnnouncement";
import { StreamingEventDetailV2 } from "./StreamingEventDetailV2";
import { EventVideoListContainerV2 } from "./StreamingEventDetailVideoListV2";
import { StreamingEventNavigation } from "./StreamingEventNavigation";
import { StreamingLiveEventV2 } from "./StreamingLiveEventV2";
import { StreamingOptions } from "./StreamingOptions";

import type { StreamingType } from "@spwn/types";
import type { FC } from "react";
import type { Store } from "store";
import type { EventInfo } from "utility";

export type Props = {
  eventInfo: EventInfo;
  mainVideoId: string;
  currentVideoId: string;
  streamingType: StreamingType;
  isOpenAnnouncement: boolean;
  isEditingAnnouncement: boolean;
  streamingAnnouncement: string;
  isLiveCommerceEnabled: boolean;
  isLiveEventEnabled: boolean;
  isOpenLiveEvent: boolean;
  handleToggleLiveEvent: () => void;
  setWatchVideo: (vid: string) => void;
  setIsEditingAnnouncement: (isEditing: boolean) => void;
  setStreamingAnnouncement: (announcement: string) => void;
  handleToggleAnnouncement: () => void;
  handleClickCommentNavigation: () => void;
  handleClickGoodsNavigation: () => void;
};

const StreamingSummaryColumn: FC<Props> = ({
  eventInfo,
  mainVideoId,
  currentVideoId,
  streamingType,
  isOpenAnnouncement,
  isEditingAnnouncement,
  streamingAnnouncement,
  isLiveCommerceEnabled,
  isLiveEventEnabled,
  isOpenLiveEvent,
  handleToggleLiveEvent,
  setWatchVideo,
  setIsEditingAnnouncement,
  setStreamingAnnouncement,
  handleToggleAnnouncement,
  handleClickCommentNavigation,
  handleClickGoodsNavigation,
}) => {
  const isAdmin = useSelector((state: Store) => state.admin.isAdmin);

  return (
    <Box
      display={"flex"}
      flexDirection={"column"}
      gridGap={"16px"}
      padding={"16px"}
    >
      <StreamingOptions
        showAnnouncement={isAdmin || streamingAnnouncement !== ""}
        handleToggleAnnouncement={handleToggleAnnouncement}
        handleToggleLiveEvent={handleToggleLiveEvent}
        isLiveEventEnabled={isLiveEventEnabled}
      />

      <SPView>
        {isOpenLiveEvent && <StreamingLiveEventV2 />}

        <StreamingAnnouncement
          eventId={eventInfo.eventId}
          mainVideoId={mainVideoId}
          streamingType={streamingType}
          isOpenAnnouncement={isOpenAnnouncement}
          isEditingAnnouncement={isEditingAnnouncement}
          setIsEditingAnnouncement={setIsEditingAnnouncement}
          streamingAnnouncement={streamingAnnouncement}
          setStreamingAnnouncement={setStreamingAnnouncement}
        />
      </SPView>

      <StreamingEventDetailV2
        event={eventInfo}
        currentVid={currentVideoId}
        setWatchVideo={setWatchVideo}
      />

      <StreamingEventNavigation
        isLiveCommerceEnabled={isLiveCommerceEnabled}
        showCommentNavigation={!eventInfo.isHiddenStreamingComment}
        handleClickCommentNavigation={handleClickCommentNavigation}
        handleClickGoodsNavigation={handleClickGoodsNavigation}
      />

      <EventVideoListContainerV2
        event={eventInfo}
        currentVid={currentVideoId}
        setWatchVideo={setWatchVideo}
      />
    </Box>
  );
};

export default StreamingSummaryColumn;
